import NavbarParallax from './NavbarParallax';
const navbar = document.querySelector('.navbar');

if (navbar) {
    NavbarParallax(navbar);
}
